import { useState, useRef, useContext } from 'react';

import { AppContext } from "../../../AppContext";

import AppOwnsDataWebApi from './../../../services/AppOwnsDataWebApi';
import { ExportFileRequest } from '../../../models/models';


import * as powerbi from "powerbi-client";
import * as models from "powerbi-models";

import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { SxProps } from '@mui/system/styleFunctionSx/styleFunctionSx';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LinearProgress from '@mui/material/LinearProgress';

import Fullscreen from '@mui/icons-material/Fullscreen';
import Edit from '@mui/icons-material/Edit';
import Pageview from '@mui/icons-material/Pageview';
import Download from '@mui/icons-material/Download';
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import Image from '@mui/icons-material/Image';
import SyncAlt from '@mui/icons-material/SyncAlt';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import FitScreen from '@mui/icons-material/FitScreen';
import PhotoSizeSelectActual from '@mui/icons-material/PhotoSizeSelectActual';

import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonChecked from '@mui/icons-material/RadioButtonChecked';
import { AppBar, Container, IconButton, Tooltip } from '@mui/material';

import Text from '../../../components/text';
import UserDropdown from '../../../components/menu';
// ensure Power BI JavaScript API has loaded
require('powerbi-models');
require('powerbi-client');

export type ViewMode = "FitToPage" | "FitToWidth" | "ActualSize";

interface ReportToolbarProps {
  report: powerbi.Report;
  editMode: boolean;
  setEditMode: (EditMode: boolean) => void;
  showNavigation: boolean;
  setShowNavigation: (ShowNavigation: boolean) => void;
  showFiltersPane: boolean;
  setShowFiltersPane: (ShowFiltersPane: boolean) => void;
  showBookmarksPane: boolean;
  setShowBookmarksPane: (ShowBookmarksPane: boolean) => void;
  viewMode: ViewMode;
  setViewMode: (VeiwModeValue: ViewMode) => void;
  setEmbedToken: (embedToken: string) => void;
  setEmbedTokenExpiration: (embedTokenExpiration: string) => void;
}

const ReportToolbar = ({ report, editMode, setEditMode, showNavigation, setShowNavigation, showFiltersPane, setShowFiltersPane,
  showBookmarksPane, setShowBookmarksPane, viewMode, setViewMode, setEmbedToken, setEmbedTokenExpiration }: ReportToolbarProps) => {

  const { embeddingData } = useContext(AppContext)
  const [anchorElementExport, setAnchorElementExport] = useState<null | HTMLElement>(null);
  const [anchorElementViewMode, setAnchorElementViewMode] = useState<null | HTMLElement>(null);
  const [openSaveAsDialog, setOpenSaveAsDialog] = useState(false);
  const [newReportName, setNewReportName] = useState("");
  const [openExportProgressDialog, setOpenExportProgressDialog] = useState(false);
  const userFullName: any = localStorage.getItem('userName');
  const currentUser = localStorage.getItem("currentUser") ?? "unknown_user";

  const refReportName = useRef<HTMLInputElement>(null);

  const menuButtonProperties: SxProps = { fontSize: "14px", color: "#444444", ml: -1, mr: -1, fontFamily:"inter, sans-serif", textTransform:"none", letterSpacing:"0" };
  const menuItemProps: SxProps = { fontSize: "14px", px: 1.5, py: 0, m: 0, fontFamily:"inter, sans-serif", color: "#444444" };
  const menuRadioButtonProps: SxProps = { ml: "auto", pl: 1.5, fontFamily:"inter, sans-serif", width:"28px", opacity:"0.9" };

  const onExportPageToPDF = async () => {

    // close Export menu and open export progress dialog
    setAnchorElementExport(null);
    setOpenExportProgressDialog(true);

    // get report data for ExportFile operation
    let reportId = report.getId();
    let currentPage = await report.getActivePage();
    let currentPageName = currentPage.name;
    let bookmark = await report.bookmarksManager.capture({ allPages: false, personalizeVisuals: false });

    // create ExportFileRequest variable with parameters for export
    const exportRequest: ExportFileRequest = {
      ReportId: reportId,
      ExportType: "PDF",
      BookmarkState: bookmark.state,
      PageName: currentPageName,
    };

    // Call ExportFile from AppOwnsDataWebApi
    await AppOwnsDataWebApi.ExportFile(exportRequest);

    // close export progress dialog
    setOpenExportProgressDialog(false);

  };

  const onExportPageToPNG = async () => {
    setAnchorElementExport(null);
    setOpenExportProgressDialog(true);
    let reportId = report.getId();
    let currentPage = await report.getActivePage();
    let currentPageName = currentPage.name;
    let bookmark = await report.bookmarksManager.capture({ allPages: false, personalizeVisuals: false });
    const exportRequest: ExportFileRequest = {
      ReportId: reportId,
      ExportType: "PNG",
      PageName: currentPageName,
      BookmarkState: bookmark.state
    };
    await AppOwnsDataWebApi.ExportFile(exportRequest);
    setOpenExportProgressDialog(false);
  };

  const onExportReportToPDF = async () => {
    setAnchorElementExport(null);
    setOpenExportProgressDialog(true);

    let reportId = report.getId();
    let bookmark = await report.bookmarksManager.capture({ allPages: false, personalizeVisuals: false });

    // create ExportFileRequest variable with parameters for export
    const exportRequest: ExportFileRequest = {
      ReportId: reportId,
      ExportType: "PDF",
      BookmarkState: bookmark.state
    };

    // Call ExportFile from AppOwnsDataWebApi
    await AppOwnsDataWebApi.ExportFile(exportRequest);

    // close dialog
    setOpenExportProgressDialog(false);
  };

  const onExportReportToPNG = async () => {
    setAnchorElementExport(null);
    setOpenExportProgressDialog(true);
    let reportId = report.getId();
    let bookmark = await report.bookmarksManager.capture({ allPages: false, personalizeVisuals: false });
    const exportRequest: ExportFileRequest = {
      ReportId: reportId,
      ExportType: "PNG",
      BookmarkState: bookmark.state
    };
    await AppOwnsDataWebApi.ExportFile(exportRequest);
    setOpenExportProgressDialog(false);
  };

  const onToggleEditMode = () => {
    report.switchMode(editMode ? "view" : "edit");
    setEditMode(!editMode);
  }

  const onViewModeFitToPage = () => {
    setAnchorElementViewMode(null);
    report.updateSettings({
      layoutType: models.LayoutType.Custom,
      customLayout: { displayOption: models.DisplayOption.FitToPage }
    });
    setViewMode("FitToPage")
  };

  const onViewModeFitToWidth = () => {
    setAnchorElementViewMode(null);
    report.updateSettings({
      layoutType: models.LayoutType.Custom,
      customLayout: { displayOption: models.DisplayOption.FitToWidth }
    });
    setViewMode("FitToWidth")
  };

  const onViewModeActualSize = () => {
    setAnchorElementViewMode(null);
    report.updateSettings({
      layoutType: models.LayoutType.Custom,
      customLayout: { displayOption: models.DisplayOption.ActualSize }
    });
    setViewMode("ActualSize")
  };

  const onReportFullscreen = () => {
    report.fullscreen();
  };

  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
		setAnchorElUser(null);
	};

  return (
    <>
      <AppBar
              position="static"
              sx={{
                bgcolor: 'white',
                boxShadow: 0,
                borderBottom: 1,
                borderColor: '#E5E7EB',
                height: '52px',
                boxSizing: 'border-box',
              }}
              style={{ height: '52px' }}
              version-info={process.env.REACT_APP_ASSIGNED_VERSION}
            >
        <Container maxWidth={false}>
					<Toolbar
						disableGutters
						className="gap-4 flex items-center"
						style={{ minHeight: '52px', height: '52px' }}
					>
            <img
              src="/assets/logos/relay.svg"
              alt="LuminUltra Relay"
              style={{ height: '43px', paddingTop:'5px' }}
            />

            <Text addStyle="!font-inter !text-[14px] !ml-2 text-primary-grey md:block hidden company" sx={{ fontWeight: "500" }}>
              {window.location.href.includes("reports") ? "Lab Reports" : "ATP Testing"}
            </Text>
            <Divider orientation='vertical' flexItem />

            <Text addStyle={`!font-inter !text-[14px] !text-primary-grey mr-2 ml-2 username`}>
              {userFullName}
            </Text>
            <Box sx={{ flexGrow: 1 }}></Box>

            <>
              <Divider orientation='vertical' flexItem sx={{ ml: "auto" }} style={{borderRight:"none"}}/>

              <Button startIcon={<Download />} endIcon={<KeyboardArrowDown />} sx={menuButtonProperties}
                onClick={(event) => { setAnchorElementExport(event.currentTarget); }} >
                Export
              </Button>
              <Menu sx={menuItemProps} anchorEl={anchorElementExport} open={Boolean(anchorElementExport)}
                onClose={() => { setAnchorElementExport(null); }} >
                <MenuItem sx={menuItemProps} onClick={onExportPageToPDF}   >
                  <PictureAsPdf sx={{ mr: 1, opacity:"0.9" }} /> Export Current Page to PDF
                </MenuItem>
                <Divider sx={{ my: 0.5 }} />
                <MenuItem sx={menuItemProps} onClick={onExportPageToPNG} disableRipple >
                  <Image sx={{ mr: 1, opacity:"0.9" }} /> Export Current Page to PNG
                </MenuItem>
                <Divider sx={{ my: 0.5, borderWidth: "1px", backgroundColor: "#666666" }} />
                <MenuItem sx={menuItemProps} onClick={onExportReportToPDF}  >
                  <PictureAsPdf sx={{ mr: 1, opacity:"0.9" }} /> Export Report to PDF
                </MenuItem>
                <Divider sx={{ my: 1.5 }} />
                <MenuItem sx={menuItemProps} onClick={onExportReportToPNG} disableRipple >
                  <Image sx={{ mr: 1, opacity:"0.9" }} /> Export Report to PNG
                </MenuItem>
              </Menu>
            </>

            <Divider orientation='vertical' flexItem />

            {embeddingData.userCanEdit &&
              <>
                <Button startIcon={editMode ? <Pageview /> : <Edit />} sx={menuButtonProperties} onClick={onToggleEditMode} >
                  {editMode ? "Reading View" : "Edit"}
                </Button>
                <Divider orientation='vertical' flexItem />
              </>
            }


            <Button startIcon={<FitScreen />} endIcon={<KeyboardArrowDown />} sx={menuButtonProperties}
              onClick={(event) => { setAnchorElementViewMode(event.currentTarget); }} >
              View Mode
            </Button>
            <Menu sx={menuItemProps} anchorEl={anchorElementViewMode} open={Boolean(anchorElementViewMode)} onClose={() => { setAnchorElementViewMode(null); }} >
              <MenuItem onClick={onViewModeFitToPage} disableRipple sx={menuItemProps}  >
                <FitScreen sx={{ mr: 1, opacity:"0.9" }} /> Fit to Page {viewMode === "FitToPage" ? <RadioButtonChecked sx={menuRadioButtonProps} /> : <RadioButtonUnchecked sx={menuRadioButtonProps} />}
              </MenuItem>
              <Divider sx={{ my: 0.5 }} />
              <MenuItem onClick={onViewModeFitToWidth} disableRipple sx={menuItemProps} >
                <SyncAlt sx={{ mr: 1, opacity:"0.9" }} /> Fit to Width {viewMode === "FitToWidth" ? <RadioButtonChecked sx={menuRadioButtonProps} /> : <RadioButtonUnchecked sx={menuRadioButtonProps} />}
              </MenuItem>
              <Divider sx={{ my: 0.5 }} />
              <MenuItem onClick={onViewModeActualSize} disableRipple sx={menuItemProps} >
                <PhotoSizeSelectActual sx={{ mr: 1, opacity:"0.9" }} /> Actual Size {viewMode === "ActualSize" ? <RadioButtonChecked sx={menuRadioButtonProps} /> : <RadioButtonUnchecked sx={menuRadioButtonProps} />}
              </MenuItem>
            </Menu>

            <Divider orientation='vertical' flexItem />

            {/* <Button startIcon={<Refresh />} sx={menuButtonProperties} onClick={onReportRefresh} >Refresh</Button>

            <Divider orientation='vertical' flexItem /> */}

            <Button startIcon={<Fullscreen />} sx={menuButtonProperties} onClick={onReportFullscreen}  >Full Screen</Button>

            <Divider orientation='vertical' flexItem sx={{ mr: 0 }} />

            <Tooltip title="Main menu">
              <IconButton
                className="open-menu"
                onClick={handleOpenUserMenu}
                sx={{ p: 0 }}
              >
                <img
                  src="/assets/icons/drawer.svg"
                  alt="Drawer Icon"
                  className="md:block hidden"
                  style={{ width: '30px', height: '38px' }}
                />
              </IconButton>
            </Tooltip>
            <UserDropdown
              anchorEl={anchorElUser}
              onClose={handleCloseUserMenu}
              userName={userFullName}
              user={currentUser}
              handleConnectToPort={() => {}}
              isConnected={false}
              isAnalyzerConnected={false}
            />

          </Toolbar>

        </Container >
      </AppBar>

      <Dialog open={openSaveAsDialog} onClose={() => { setOpenSaveAsDialog(false); }} >
        <DialogTitle>Enter report name</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You need to give this new report a name.
          </DialogContentText>
          <TextField
            onChange={(event) => { setNewReportName(event.target.value) }}
            autoFocus
            margin="dense"
            id="name"
            label="New Report Name"
            type="text"
            value={newReportName}
            fullWidth
            variant="standard"
            inputRef={refReportName}
          />
        </DialogContent>
        <DialogActions>
          <Button disabled={newReportName === ""} onClick={async () => {
            setOpenSaveAsDialog(false);
            await report.saveAs({ name: newReportName });
          }}>Save</Button>
          <Button onClick={() => { setOpenSaveAsDialog(false); }}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openExportProgressDialog} onClose={() => { setOpenExportProgressDialog(false); }} >
        <DialogTitle>Export in progress</DialogTitle>
        <DialogContent >
          <DialogContentText sx={{ display: "block", verticalAlign: "middle", width: "100%", backgroundColor: "lightblue" }} >
            <LinearProgress />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenExportProgressDialog(false); }}>Dismiss</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ReportToolbar